import { create } from "zustand";
import { DisengagedProduct, signInCredsModel } from "./types";

export interface IStoreState {
  showPassword: boolean;
  rememberMe: boolean;
  setRememberMe: (rememberMe: boolean) => void;
  setShowPassword: (val: boolean) => void;

  //animations
  leftAnimComplete: boolean;
  rightAnimComplete: boolean;
  gridAnimComplete: boolean;
  setLeftAnimComplete: (value: boolean) => void;
  setRightAnimComplete: (value: boolean) => void;
  setGridAnimComplete: (value: boolean) => void;

  value1: string;
  setValue1: (value: string) => void;
  value2: string;
  setValue2: (value: string) => void;
  value3: string;
  setValue3: (value: string) => void;
  value4: string;
  setValue4: (value: string) => void;
  value5: string;
  setValue5: (value: string) => void;
  value6: string;
  setValue6: (value: string) => void;

  errorMessage: string;
  setErrorMessage: (msg: string) => void;

  countdown: number;
  setCountdown: (val: number) => void;

  maxSessionDialogOpen: boolean;
  setMaxSessionDialogOpen: (val: boolean) => void;

  facilityArchivedDialogOpen: boolean;
  setFacilityArchivedDialogOpen: (val: boolean) => void;
  facilityArchivedMessage?: string;
  setFacilityArchivedMessage: (message?: string) => void;

  facilityDisengagedDialogOpen: boolean;
  setFacilityDisengagedDialogOpen: (val: boolean) => void;

  postDisengageLoading: boolean;
  setPostDisengageLoading: (v: boolean) => void;

  disengagedProductNames?: DisengagedProduct[];
  setDisengagedProductNames: (products?: DisengagedProduct[]) => void;

  pendingSignInPayload?: signInCredsModel;
  setPendingSignInPayload: (payload?: signInCredsModel) => void;

  triggerSignIn?: (payload: signInCredsModel) => void;
  setTriggerSignIn: (fn: (payload: signInCredsModel) => void) => void;
}

const signInStore = create<IStoreState>((set) => ({
  showPassword: false,
  rememberMe: false,
  setRememberMe: (rememberMe: boolean) => set({ rememberMe }),
  setShowPassword: (showPassword: boolean) => set({ showPassword }),

  // animations
  leftAnimComplete: false,
  rightAnimComplete: false,
  gridAnimComplete: false,
  setLeftAnimComplete: (value: boolean) => set({ leftAnimComplete: value }),
  setRightAnimComplete: (value: boolean) => set({ rightAnimComplete: value }),
  setGridAnimComplete: (value: boolean) => set({ gridAnimComplete: value }),

  value1: "",
  setValue1: (value: string) => set({ value1: value }),
  value2: "",
  setValue2: (value: string) => set({ value2: value }),
  value3: "",
  setValue3: (value: string) => set({ value3: value }),
  value4: "",
  setValue4: (value: string) => set({ value4: value }),
  value5: "",
  setValue5: (value: string) => set({ value5: value }),
  value6: "",
  setValue6: (value: string) => set({ value6: value }),

  errorMessage: "",
  setErrorMessage: (msg: string) => set({ errorMessage: msg }),

  countdown: 0,
  setCountdown: (val: number) => set({ countdown: val }),

  maxSessionDialogOpen: false,
  setMaxSessionDialogOpen: (val: boolean) => set({ maxSessionDialogOpen: val }),

  facilityArchivedDialogOpen: false,
  setFacilityArchivedDialogOpen: (facilityArchivedDialogOpen: boolean) =>
    set({ facilityArchivedDialogOpen }),
  facilityArchivedMessage: undefined,
  setFacilityArchivedMessage: (facilityArchivedMessage?: string) =>
    set({ facilityArchivedMessage }),

  facilityDisengagedDialogOpen: false,
  setFacilityDisengagedDialogOpen: (facilityDisengagedDialogOpen: boolean) =>
    set({ facilityDisengagedDialogOpen }),

  postDisengageLoading: false,
  setPostDisengageLoading: (v) => set({ postDisengageLoading: v }),

  disengagedProductNames: undefined,
  setDisengagedProductNames: (disengagedProductNames?: DisengagedProduct[]) =>
    set({ disengagedProductNames }),

  pendingSignInPayload: undefined,
  setPendingSignInPayload: (payload?: signInCredsModel) =>
    set({ pendingSignInPayload: payload }),

  triggerSignIn: undefined,
  setTriggerSignIn: (fn) => set({ triggerSignIn: fn }),
}));

export const useSignInStore = signInStore;
